import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { style: {"color":"#000"} }, [
  /*#__PURE__*/_createElementVNode("span", null, " 导入“国家/地区”货币数据 ")
], -1)
const _hoisted_2 = { "element-loading-text": "正在保存数据，请稍后" }
const _hoisted_3 = { class: "dialog-footer" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 选择文件 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("确 定")

import { reactive, h } from 'vue';
import { CurrencyImportApi } from '../../../../apis/basics/nation.api';
import { ElMessage } from 'element-plus';
import * as xlsx from "xlsx";


export default /*#__PURE__*/_defineComponent({
  emits: ['onSaveSuccess'],
  setup(__props, { expose, emit: $emits }) {



const state = reactive({
    loading: false,
    fileList: [] as any[],
    tableData: [] as any[],
    showDialog: false,
})

const actions = {
    /* 读取Excel文件 */
    readFile: (file: File) => {
        return new Promise(resolve => {
            let reader = new FileReader();
            reader.readAsBinaryString(file);
            reader.onload = ev => {
                resolve(ev.target?.result);
            }
        });
    },
    /* 读取Excel文件内容 */
    readExcelFile: async (file: File, sheetIndex: number) => {
        let data = await actions.readFile(file);
        let workbook = xlsx.read(data, { type: 'binary' });

        let worksheet = workbook.Sheets[workbook.SheetNames[sheetIndex]];
        data = xlsx.utils.sheet_to_json(worksheet);

        const _data = JSON.parse(JSON.stringify(data));
        const _json = [] as any;

        _data.forEach((item: any) => {
            _json.push({
                nation_code: (item.国家代码 ?? '') + '',
                nation_name_cn: (item.国家中文 ?? '') + '',
                nation_name_en: (item.国家英文 ?? '') + '',
                nation_full_name: (item.国家全称 ?? '') + '',
                nation_iso_code: (item.三位码 ?? '') + '',
                currency_name_cn: (item.货币中文 ?? '') + '',
                currency_name_en: (item.货币英文 ?? '') + '',
                symbol_tandard: (item.货币标准符号 ?? '') + '',
                symbol_once: (item.原有旧符号 ?? '') + '',
            });
        });

        return _json;
    },
    uploadChange: async (options: any) => {
        state.loading = true
        const data = await actions.readExcelFile(options.raw, 0);
        state.tableData = data;
        state.loading = false
    },
    save: async () => {

        state.loading = true;
        const currencyList = (state.tableData ?? []).map(item => {
            return {
                nation_iso_code: item.nation_iso_code,
                currency_name_cn: item.currency_name_cn,
                currency_name_en: item.currency_name_en,
                symbol_tandard: item.symbol_tandard,
                symbol_once: item.symbol_once,
            };
        });

        const onSuccess = ((res: any) => {
            const { succeeded, errors } = res
            if (!succeeded) {
                ElMessage.error(errors)
            } else {
                ElMessage.success('导入成功')
                state.showDialog = false;
            }
        });

        const onError = ((err: any) => {
            ElMessage.error(err.message);
        })

        const onFinally = () => {
            $emits('onSaveSuccess')
            state.loading = false;
        }

        await CurrencyImportApi(currencyList).then(onSuccess).catch(onError).finally(onFinally);
    }
}

const expFuncs = {
    openDialog: () => {
        state.fileList = [];
        state.tableData = [];
        state.showDialog = true;
    }
}

expose({ ...expFuncs })


return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _unref(state).showDialog,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).showDialog) = $event)),
    size: "small",
    width: 1000
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_3, [
        _createVNode(_component_el_button, {
          disabled: _unref(state).loading,
          size: "small"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_upload, {
              ref: "uploadRef",
              "file-list": _unref(state).fileList,
              "onUpdate:file-list": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).fileList) = $event)),
              limit: 1,
              action: "",
              "show-file-list": false,
              "auto-upload": false,
              "on-change": actions.uploadChange,
              accept: "xlsx,xls"
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["file-list", "on-change"])
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          disabled: _unref(state).loading,
          size: "small",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(state).showDialog = false))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          disabled: _unref(state).loading,
          size: "small",
          type: "primary",
          onClick: actions.save
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(_component_el_table, {
          size: "small",
          data: _unref(state).tableData,
          style: {"width":"100%"},
          "row-key": "id",
          border: "",
          height: "500"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              type: "index",
              label: "序号",
              width: "55",
              fixed: "",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "nation_code",
              label: "国家代码",
              "min-width": "100",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "nation_name_cn",
              label: "国家名称(中文)",
              "min-width": "100",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "nation_name_en",
              label: "国家名称(英文)",
              "min-width": "100",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "nation_full_name",
              label: "全称",
              "min-width": "100",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "nation_iso_code",
              label: "ISO3186",
              "min-width": "100",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "currency_name_cn",
              label: "货币名称(中文)",
              "min-width": "100",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "currency_name_en",
              label: "货币名称(英文)",
              "min-width": "100",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "symbol_once",
              label: "货币曾用符号",
              "min-width": "100",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "symbol_tandard",
              label: "货币标准符号",
              "min-width": "100",
              "show-overflow-tooltip": ""
            })
          ]),
          _: 1
        }, 8, ["data"])
      ])), [
        [_directive_loading, _unref(state).loading]
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})